export enum PRODUCT_LINE_CODES {
  CementBulk = '0001',
  CementBag = '0002',
  MultiProduct = '0003',
  Cement = '0004',
  Aggregates = '0005',
  Readymix = '0006',
  CementBulkMultiProduct = '0002,0003',
}
